import { useCallback, useState } from 'react';

import { useHistory } from 'react-router-dom';

import { ImageLogoAtom } from '~/assets/images/';
import { Button } from '~/components';

import {
  Container,
  Header,
  Content,
  Footer,
  CheckboxContainer,
  Checkbox,
} from './styles';

const SignUpPolicyPrivacy = () => {
  const { push } = useHistory();

  const [checkboxIsFilled, setCheckboxIsFilled] = useState(false);

  const navigateToSignPlan = useCallback(() => {
    push('/sign-plan');
  }, [push]);

  return (
    <Container>
      <Header>
        <div className="logo-container">
          <ImageLogoAtom />
        </div>

        <nav>
          <h1>Política de privacidade</h1>
        </nav>
      </Header>

      <Content>
        <p>
          A presente Política de Privacidade contém informações sobre coleta,
          uso, armazenamento, tratamento e proteção dos dados pessoais dos
          usuários e visitantes do aplicativo iB – Intelligent Business e do
          site www.ibintelligentbusiness.com, com a finalidade de demonstrar
          absoluta transparência quanto ao assunto e esclarecer a todos
          interessados sobre os tipos de dados que são coletados, os motivos da
          coleta e a forma como os usuários podem gerenciar ou excluir as suas
          informações pessoais.
          <br /> Esta Política de Privacidade aplica-se a todos os usuários e
          visitantes do aplicativo iB – Intelligent Business OU site
          www.ibintelligentbusiness.com, e integra os Termos Uso do aplicativo
          iB – Intelligent Business OU site{' '}
          <a
            href="http://www.ibintelligentbusiness.com"
            target="_blank"
            rel="noreferrer"
          >
            http://www.ibintelligentbusiness.com
          </a>
          devidamente inscrita no CNPJ sob o número 40.884.183/0001-70, situada
          em Rua Prudente de Moraes Neto, 91, Recreio dos bandeirantes, Rio de
          Janeiro, Brasil, doravante nominada plataforma. O presente documento
          foi elaborado em conformidade com a Lei Geral de Proteção de Dados
          Pessoais (Lei 13.709/18), o Marco Civil da Internet (Lei 12.965/14) (e
          o Regulamento da UE n. 2016/6790). Ainda, o documento poderá ser
          atualizado em decorrência de eventual atualização normativa, razão
          pela qual se convida o usuário a consultar periodicamente esta seção.
        </p>

        <p>
          <h2>COMO RECLHEMOS OS DADOS PESSOAIS DO USUÁRIO E DO VISITANTE?</h2>
          Os dados pessoais do usuário e visitante são recolhidos pela
          plataforma da seguinte forma: <br />• Quando o usuário cria uma
          conta/perfil em nossa plataforma: esses dados são os dados de
          identificação básicos, como: Nome completo, e-mail, número do registro
          profissional, CPF, endereço, gênero (para perfil “Professor”), Razão
          Social, Nome fantasia, CNPJ, endereço da sede (para perfil
          “Academia”).
          <br /> A partir deles, podemos identificar o usuário e o visitante,
          além de garantir uma maior segurança e bem-estar às suas necessidades.{' '}
          <br />
          Ficam cientes os usuários e visitantes de que seu perfil na plataforma
          estará acessível a todos demais usuários e visitantes da plataforma iB
          – Intelligent Business. <br />• Quando um usuário e visitante acessa
          páginas do site{' '}
          <a
            href="http://www.ibintelligentbusiness.com"
            target="_blank"
            rel="noreferrer"
          >
            http://www.ibintelligentbusiness.com
          </a>
          OU o aplicativo iB – Intelligent Business: as informações sobre
          interação e acesso são coletadas pela empresa para garantir uma melhor
          experiência ao usuário e visitante.
          <br />
          Estes dados podem tratar sobre as palavras-chaves utilizadas em uma
          busca, o compartilhamento de um documento específico, comentários,
          visualizações de páginas, perfis, a URL de onde o usuário e visitante
          provêm, o navegador que utilizam e seus IPs de acesso, dentre outras
          que poderão ser armazenadas e retidas.
        </p>

        <p>
          <h2>QUAIS DADOS PESSOAIS RECOLHEMOS SOBRE O USUÁRIO E VISITANTE?</h2>
          Os dados pessoais do usuário e visitante recolhidos são os seguintes:{' '}
          <br />• Dados para a criação da conta/perfil na plataforma: Nome
          completo, e-mail, número do registro profissional, CPF, endereço,
          gênero (para perfil “Professor”), Razão Social, Nome fantasia, CNPJ,
          endereço da sede (para perfil “Academia”). <br />• Dados para
          concretizar transações: dados referentes ao pagamento e transações,
          tais como, número do cartão de crédito e outras informações sobre o
          cartão, além dos pagamentos efetuados. <br />• Newsletter: o e-mail
          cadastrado pelo visitante que optar por se inscrever na Newsletter
          será coletado e armazenado até que o usuário solicite o descadastro.{' '}
          <br /> • Dados sensíveis: a plataforma poderá coletar os seguintes
          dados sensíveis do usuário – Gênero. <br />• Dados relacionados a
          contratos: diante da formalização do contrato de compra e venda ou de
          prestação de serviços entre a plataforma e o usuário e visitante
          poderão ser coletados e armazenados dados relativos à execução
          contratual, inclusive as comunicações realizadas entre a empresa e o
          usuário. <br />• Outros.
        </p>

        <p>
          <h2>
            PARA QUE FINALIDADES UTILIZAMOS OS DADOS PESSOAIS DO USUÁRIO E
            VISITANTE?
          </h2>
          Os dados pessoais do usuário e do visitante coletados e armazenados
          pela plataforma iB – Intelligent Business tem por finalidade: <br /> •
          Bem-estar do usuário e visitante: aprimorar o produto e/ou serviço
          oferecido, facilitar, agilizar e cumprir os compromissos estabelecidos
          entre o usuário e a empresa, melhorar a experiência dos usuários e
          fornecer funcionalidades específicas a depender das características
          básicas do usuário. <br />• Melhorias da plataforma: compreender como
          o usuário utiliza os serviços da plataforma, para ajudar no
          desenvolvimento de negócios e técnicas. <br /> • Anúncios: apresentar
          anúncios personalizados para o usuário com base nos dados fornecidos.{' '}
          <br />• Comercial: os dados são usados para personalizar o conteúdo
          oferecido e gerar subsídio à plataforma para a melhora da qualidade no
          funcionamento dos serviços. <br />• Previsão do perfil do usuário:
          tratamento automatizados de dados pessoais para avaliar o uso na
          plataforma. <br />• Dados de cadastro: para permitir o acesso do
          usuário a determinados conteúdos da plataforma, exclusivo para
          usuários cadastrados <br />• Dados de contrato: conferir às partes
          segurança jurídica e facilitar a conclusão do negócio. <br />• Outros.
          O tratamento de dados pessoais para finalidades não previstas nesta
          Política de Privacidade somente ocorrerá mediante comunicação prévia
          ao usuário, de modo que os direitos e obrigações aqui previstos
          permanecem aplicáveis.
        </p>

        <p>
          <h2>POR QUANTO TEMPO OS DADOS PESSOAIS FICAM ARMAZENADOS</h2>
          Os dados pessoais do usuário e visitante são armazenados pela
          plataforma durante o período necessário para a prestação do serviço ou
          o cumprimento das finalidades previstas no presente documento,
          conforme o disposto no inciso I do artigo 15 da Lei 13.709/18. <br />
          Os dados podem ser removidos ou anonimizados a pedido do usuário,
          excetuando os casos em que a lei oferecer outro tratamento. <br />
          Ainda, os dados pessoais dos usuários apenas podem ser conservados
          após o término de seu tratamento nas seguintes hipóteses previstas no
          artigo 16 da referida lei: <br />I - Cumprimento de obrigação legal ou
          regulatória pelo controlador; <br />
          II - Estudo por órgão de pesquisa, garantida, sempre que possível, a
          anonimização dos dados pessoais; <br />
          III - Transferência a terceiro, desde que respeitados os requisitos de
          tratamento de dados dispostos nesta Lei; <br />
          IV - Uso exclusivo do controlador, vedado seu acesso por terceiro, e
          desde que anonimizados os dados.
        </p>

        <p>
          <h2>SEGURANÇA DOS DADOS PESSOAIS ARMAZENADOS</h2>A plataforma se
          compromete a aplicar as medidas técnicas e organizativas aptas a
          proteger os dados pessoais de acessos não autorizados e de situações
          de destruição, perda, alteração, comunicação ou difusão de tais dados.
          <br /> Os dados relativos a cartões de crédito são criptografados
          usando a tecnologia &quot;secure socket layer&quot; (SSL) que garante
          a transmissão de dados de forma segura e confidencial, de modo que a
          transmissão dos dados entre o servidor e o usuário ocorre de maneira
          cifrada e encriptada.
          <br /> A plataforma não se exime de responsabilidade por culpa
          exclusiva de terceiro, como em caso de ataque de hackers ou crackers,
          ou culpa exclusiva do usuário, como no caso em que ele mesmo transfere
          seus dados a terceiros. <br />O iB – Intelligent Business se
          compromete a comunicar o usuário em caso de alguma violação de
          segurança dos seus dados pessoais. <br />
          Os dados pessoais armazenados são tratados com confidencialidade,
          dentro dos limites legais. <br />
          No entanto, podemos divulgar suas informações pessoais caso sejamos
          obrigados pela lei para fazê-lo ou se você violar nossos Termos de
          Serviço.
        </p>

        <p>
          <h2>COMPARTILHAMENTO DOS DADOS</h2>O compartilhamento de dados do
          usuário ocorre apenas com os dados referentes a publicações realizadas
          pelo próprio usuário, tais ações são compartilhadas publicamente com
          os outros usuários.
        </p>

        <p>
          <h2>OS DADOS PESSOAIS ARMAZENADOS SERÃO TRANSFERIDOS A TERCEIROS?</h2>
          Os terceiros indicados recebem os dados na medida do necessário para
          permitir que eles realizem os serviços contratados.
          <br /> Com relação aos fornecedores de serviços terceirizados como
          processadores de transação de pagamento, informamos que cada qual tem
          sua própria política de privacidade. Desse modo, recomendamos a
          leitura das suas políticas de privacidade para compreensão de quais
          informações pessoais serão usadas por esses fornecedores. Os
          fornecedores podem ser localizados ou possuir instalações localizadas
          em países diferentes.
          <br /> Nessas condições, os dados pessoais transferidos podem se
          sujeitar às leis de jurisdições nas quais o fornecedor de serviço ou
          suas instalações estão localizados. <br />
          Ao acessar nossos serviços e prover suas informações, você está
          consentindo o processamento, transferência e armazenamento desta
          informação em outros países.
          <br /> Ao ser redirecionado para um aplicativo ou site de terceiros,
          você não será mais regido por essa Política de Privacidade ou pelos
          Termos de Serviço da nossa plataforma. <br />
          Não somos responsáveis pelas práticas de privacidade de outros sites e
          lhe incentivamos a ler as declarações de privacidade deles.
        </p>

        <p>
          <h2>COOKIES OU DADOS DE NAVEGAÇÃO</h2>
          Os cookies referem-se a arquivos de texto enviados pela plataforma ao
          computador do usuário e visitante e que nele ficam armazenados, com
          informações relacionadas à navegação no site.
          <br /> Tais informações são relacionadas aos dados de acesso como
          local e horário de acesso e são armazenadas pelo navegador do usuário
          e visitante para que o servidor da plataforma possa lê-las
          posteriormente a fim de personalizar os serviços da plataforma.
          <br /> O usuário e o visitante da plataforma iB – Intelligent Business
          manifesta conhecer e aceitar que pode ser utilizado um sistema de
          coleta de dados de navegação mediante à utilização de cookies.
          <br /> O cookie persistente permanece no disco rígido do usuário e
          visitante depois que o navegador é fechado e será usado pelo navegador
          em visitas subsequentes ao site.
          <br /> Os cookies persistentes podem ser removidos seguindo as
          instruções do seu navegador.
          <br /> Já o cookie de sessão é temporário e desaparece depois que o
          navegador é fechado.
          <br /> É possível redefinir seu navegador da web para recusar todos os
          cookies, porém alguns recursos da plataforma podem não funcionar
          corretamente se a capacidade de aceitar cookies estiver desabilitada.
        </p>

        <p>
          <h2>CONSENTIMENTO</h2>
          Ao utilizar os serviços e fornecer as informações pessoais na
          plataforma, o usuário está consentindo com a presente Política de
          Privacidade. <br />O usuário, ao cadastrar-se, manifesta conhecer e
          pode exercitar seus direitos de cancelar seu cadastro, acessar e
          atualizar seus dados pessoais e garante a veracidade das informações
          por ele disponibilizadas. <br />O usuário tem direito de retirar o seu
          consentimento a qualquer tempo, para tanto deve entrar em contato
          através do e-mail <strong>suporte@ibintelligentbusiness.com</strong> .
        </p>

        <p>
          <h2>ALTERAÇÕES PARA ESSA POLÍTICA DE PRIVACIDADE</h2>
          Reservamos o direito de modificar essa Política de Privacidade a
          qualquer momento, então, é recomendável que o usuário e visitante
          revise-a com frequência.
          <br /> As alterações e esclarecimentos vão surtir efeito imediatamente
          após sua publicação na plataforma. Quando realizadas alterações os
          usuários serão notificados.
          <br /> Ao utilizar o serviço ou fornecer informações pessoais após
          eventuais modificações, o usuário e visitante demonstra sua
          concordância com as novas normas.
          <br />
          Diante da fusão ou venda da plataforma à outra empresa os dados dos
          usuários podem ser transferidos para os novos proprietários para que a
          permanência dos serviços oferecidos.
        </p>

        <p>
          <h2>JURISDIÇÃO PARA RESOLUÇÃO DE CONFLITOS</h2>
          Para a solução de controvérsias decorrentes do presente instrumento
          será aplicado integralmente o Direito brasileiro.
          <br /> Os eventuais litígios deverão ser apresentados no foro da
          comarca em que se encontra a sede da empresa.
        </p>
      </Content>

      <Footer>
        <CheckboxContainer
          onClick={() => setCheckboxIsFilled((prevState) => !prevState)}
        >
          <Checkbox isFilled={checkboxIsFilled} />

          <span>Li e concordo com os termos de uso.</span>
        </CheckboxContainer>

        <Button onClick={navigateToSignPlan} buttonDisable={!checkboxIsFilled}>
          CONTINUAR
        </Button>
      </Footer>
    </Container>
  );
};

export default SignUpPolicyPrivacy;
